export type InstallBrowser = { userAgent: string; platform: string; maxTouchPoints: number };

export function classifyInstallContext({ userAgent: ua, platform, maxTouchPoints }: InstallBrowser) {
  const ios = /iPhone|iPad|iPod/.test(ua) || (platform === "MacIntel" && maxTouchPoints > 1);
  const embedded = /MicroMessenger|FBAN|FBAV|Instagram|\bLine\/|\bQQ\/|TikTok|Twitter/i.test(ua);
  const safari = /Safari\//.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|YaBrowser/.test(ua);
  const browser = /MicroMessenger/i.test(ua) ? "WeChat" : /Instagram/i.test(ua) ? "Instagram" : /FBAN|FBAV/i.test(ua) ? "Facebook" : /\bQQ\//i.test(ua) ? "QQ" : "";
  return { ios, embedded, browser, desktop: !ios && !/Android|Mobile/i.test(ua), handoff: !ios || embedded || !safari };
}

export const getInstallContext = () => classifyInstallContext(navigator);

export function installLink(origin: string, videoOrigin: string, parentOrigins: readonly string[]) {
  return new URL("/?install=1", origin === videoOrigin ? parentOrigins[0] || origin : origin).href;
}
